import { createRelayResource } from '@atlassian/help-center-common-util/resource-router/resource-router';
import type { emptyStateQuery } from '../../ui/__generated__/emptyStateQuery.graphql';
import EmptyStateQuery from '../../ui/__generated__/emptyStateQuery.graphql';
import { MAX_ITEMS_PER_PAGE } from '../../ui/types';

/*
    We need to create a duplicate of the folder resource request for empty folders.
    This is because we can't include the parentId param in the request
 */
export const CsmEmptyFolderResource = createRelayResource<emptyStateQuery>({
    type: 'CSM_FOLDER',
    getQuery: ({ match }, { cloudId, helpCenterAri }) => {
        const pageId = match.params.folderId || '';
        return {
            parameters: EmptyStateQuery,
            variables: {
                cloudId,
                helpCenterAri,
                first: MAX_ITEMS_PER_PAGE,
                input: {
                    articleIds: [pageId],
                },
            },
            options: {
                fetchPolicy: 'store-or-network',
            },
        };
    },
});
